module.exports = __webpack_public_path__ + "media/3_5-2.7399cbea.mp3";